import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import Substructure from '@Pages/RetroSynthesis/ProjectParametersDialog/Substructure/Substructure';
import { PredictedIktosParams } from '../../constants';

import './IntermediatesParameter.theme.scss';

function IntermediatesParameter({ smiles, paramName }) {
  const [visible, setVisible] = useState(false);
  const label = paramName === PredictedIktosParams.INCLUDE_SUBSTRUCTURES ? 'included' : 'excluded';
  if (paramName === PredictedIktosParams.EXCLUDE_SUBSTRUCTURES && !smiles) {
    return null;
  }
  return (
    <div className="intermediates-param predicted-param">
      <div className="intermediates-param__header" id={paramName}>
        <div className="intermediates-param__header-title">
          {smiles && (
            <>
              <b>{smiles.length}</b> intermediates {label}
            </>
          )}
          {!smiles && (
            <>
              <b>No</b> intermediates defined
            </>
          )}
        </div>
        {smiles && smiles.length > 0 && (
          <Button
            buttonConfig={{
              type: 'link',
              size: 'sm',
              label: visible ? 'Hide' : 'Show',
              e2eName: 'intermediates-section-toggle',
              ariaLabel: 'Toggle intermediates',
              className: 'intermediates-param__header-button',
            }}
            iconConfig={{ name: visible ? 'chevron-up' : 'chevron-down' }}
            onClick={() => setVisible(!visible)}
            aria-expanded={visible}
            aria-controls={`${paramName}Content`}
          />
        )}
      </div>
      {visible && (
        <div className="intermediates-param__content" id={`${paramName}Content`} role="region" aria-labelledby={paramName}>
          {smiles.map((smile) => {
            return <Substructure key={smile.value} smiles={smile} displayRemoveIcon={false} />;
          })}
        </div>
      )}
    </div>
  );
}

IntermediatesParameter.propTypes = {
  smiles: PropTypes.array,
  paramName: PropTypes.string,
};

export default IntermediatesParameter;
